var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Icon } from "../../UI";

import { t, Translate } from "../../I18N";
import { notificationActions } from "../../Notifications";

import { updateSelection, updateFormField } from "../actions/metadataExtractionActions";














const mapStateToProps = (state) => ({
  selection: state.documentViewer.uiState.
  get('reference').
  get('sourceRange')
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { fieldName, fieldId, model, fieldType, locale } = ownProps;
  return bindActionCreators(
    {
      updateField: (value) => async (dis) => {
        const action = await updateFormField(value, model, fieldType, locale);
        dis(action);
      },
      setSelection: (selection) => updateSelection(selection, fieldName, fieldId),
      notify: notificationActions.notify
    },
    dispatch
  );
};

const connector = connect(mapStateToProps, mapDispatchToProps);



const MetadataExtractorComponent = ({
  selection,
  setSelection,
  updateField,
  notify
}) => {
  const onClick = async () => {var _selection$selectionR;
    if (!((_selection$selectionR = selection.selectionRectangles) !== null && _selection$selectionR !== void 0 && _selection$selectionR.length)) {
      notify(
        t('System', 'Could not detect the area for the selected text', null, false),
        'warning'
      );
    }
    setSelection(selection);
    updateField(selection.text);
  };

  if (!selection) {
    return null;
  }

  return /*#__PURE__*/(
    _jsx("button", { type: "button", onClick: onClick, className: "extraction-button" }, void 0, /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Click to fill"), " ", /*#__PURE__*/_jsx(Icon, { icon: "bullseye" })
    )
    ));

};

const container = connector(MetadataExtractorComponent);


export { container as MetadataExtractor };